export const environment = {
  production: false,
  apiUrl: 'https://api.staging.rekruto.io/api/v1',
};
